import { useEffect, useState } from "react";
import { Table, Button } from "antd";
import { UserAddOutlined } from "@ant-design/icons";
import ModifyWarehouseDrawer from "../component/ModifyWarehouseDrawer.jsx";
import { useNavigate } from "react-router-dom";

const AdminPage = () => {
    const [open, setOpen] = useState(false);
    const [warehouseDetails, setWarehouseDetails] = useState([]);
    const [dropdown, setDropdown] = useState({
        Region: null,
        Warehouse: null,
    });

    const navigate = useNavigate();

    const userDetails = JSON.parse(sessionStorage.getItem("userdetails"));

    useEffect(() => {
        fetchWarehouselist();
    }, []);

    const fetchWarehouselist = async () => {
        try {
            const formData = new FormData();
            formData.append("id", userDetails?.id);

            const response = await fetch(
                "https://ambronex.in/apis/WarehouseList.php",
                {
                    method: "POST",
                    body: formData,
                }
            );

            const result = await response.json();

            if (
                result.status === "success" &&
                Array.isArray(result.data)
            ) {
                const formatted = result.data.map((item, index) => ({
                    key: index + 1,
                    region: item.region,
                    location: item.wh_name,
                    total_capacity:
                        item.capacity_summary?.[0]?.total_capacity || 0,
                    occupancy:
                        item.capacity_summary?.[0]?.occupancy || 0,
                    available:
                        item.capacity_summary?.[0]?.available || 0,
                    occupancy_percentage:
                        item.capacity_summary?.[0]
                            ?.occupancy_percentage || 0,
                    available_percentage:
                        item.capacity_summary?.[0]
                            ?.available_percentage || 0,
                }));

                setDropdown({
                    Region: [...new Set(result.data.map(item => item.region))],
                    Warehouse: result.data.map(item => ({
                        id: item.wh_id,
                        name: item.wh_name,
                        region: item?.region,
                    }))
                });
                setWarehouseDetails(formatted);
            } else {
                setWarehouseDetails([]); // always array
            }
        } catch (err) {
            console.error("Fetch Error:", err);
            setWarehouseDetails([]); // prevent crash
        }
    };

    const columns = [
        {
            title: "S.No",
            dataIndex: "key",
        },
        {
            title: "Region",
            dataIndex: "region",
        },
        {
            title: "Location",
            dataIndex: "location",
        },
        {
            title: "Total Capacity",
            dataIndex: "total_capacity",
        },
        {
            title: "Occupancy",
            dataIndex: "occupancy",
        },
        {
            title: "Available",
            dataIndex: "available",
        },
        {
            title: "Occupancy %",
            render: (_, record) =>
                `${record.occupancy_percentage}%`,
        },
        {
            title: "Available %",
            render: (_, record) =>
                `${record.available_percentage}%`,
        },
    ];

    return (
        <div className="container min-vh-100 py-4">
            {/* Top Header */}
            <div className="d-flex justify-content-between align-items-center mb-4">
                <h3 className="fw-bold text-primary">Warehouse Admin Panel</h3>

                <div className="d-flex gap-2">
                    <Button icon={<UserAddOutlined />} type="default">
                        Tender
                    </Button>

                    <Button
                        type="primary"
                        className="bg-success"
                        onClick={() => navigate("/warehouse-Admin/report")}
                    >
                        <i className="bi bi-bar-chart"></i> Report
                    </Button>

                    <Button
                        type="primary"
                        onClick={() => setOpen(true)}
                    >
                        <i class="bi bi-houses"></i>
                        Warehouse
                    </Button>

                    <ModifyWarehouseDrawer
                        open={open}
                        onClose={() => setOpen(false)}
                        dropdown={dropdown}
                        fetchWarehouselist={fetchWarehouselist}
                    />
                </div>
            </div>

            {/* Table Card */}
            <div className="card shadow-sm border-0">
                <div className="card-body">
                    <style>
                        {`
                            .custom-ant-table .ant-table-thead > tr > th {
                            background-color: #536aa0;
                            color: white;
                            font-weight: 600;
                            text-align: center;
                            }

                            .custom-ant-table .ant-table {
                            border-radius: 10px;
                            overflow: hidden;
                            }

                            .custom-ant-table .ant-table-tbody > tr:hover > td {
                            background: #f5f7ff;
                            }
                            
                        `}
                    </style>

                    <Table
                        className="custom-ant-table"
                        columns={columns}
                        dataSource={warehouseDetails || []}
                        bordered
                        scroll={{ x: "max-content" }}
                        pagination={{
                            // pageSize: 10,
                            showSizeChanger: true,
                            pageSizeOptions: ["10", "20", "50"],
                            position: ["bottomRight"]
                        }}
                    />
                </div>
            </div>
        </div >
    );
};

export default AdminPage;